import { render, staticRenderFns } from "./ReviewFieldsSettings.vue?vue&type=template&id=56e6afd3&scoped=true"
import script from "./ReviewFieldsSettings.vue?vue&type=script&lang=ts"
export * from "./ReviewFieldsSettings.vue?vue&type=script&lang=ts"
import style0 from "./ReviewFieldsSettings.vue?vue&type=style&index=0&id=56e6afd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6afd3",
  null
  
)

export default component.exports